/**
 * @generated SignedSource<<8c9c11bea16e8e26fdc63f216c6ec8e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ContactChannelSelectorQuery$variables = {};
export type ContactChannelSelectorQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly allowExternalInviting: boolean | null;
      readonly allowInviting: boolean | null;
      readonly emailDomainList: ReadonlyArray<string>;
      readonly guestUsersAllowInvite: boolean;
      readonly isPersonalType: boolean;
    };
  };
};
export type ContactChannelSelectorQuery = {
  response: ContactChannelSelectorQuery$data;
  variables: ContactChannelSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowInviting",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guestUsersAllowInvite",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExternalInviting",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPersonalType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactChannelSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ContactChannelSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bac53001125ecc35af5389941c0025da",
    "id": null,
    "metadata": {},
    "name": "ContactChannelSelectorQuery",
    "operationKind": "query",
    "text": "query ContactChannelSelectorQuery {\n  viewer {\n    account {\n      allowInviting\n      guestUsersAllowInvite\n      allowExternalInviting\n      isPersonalType\n      emailDomainList\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b18eb8f615d4d6c9630a66189caa13fe";

export default node;
